import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BarChart3 } from "lucide-react";
import { ReportPageHeader } from "./ReportPageHeader.js";
import { REPORTS_NAV_ITEMS } from "./reports-nav.js";

/** Landing cards only — no BI charts. */
export function AllReportsPage(): React.JSX.Element {
  const { t } = useTranslation();
  const cards = REPORTS_NAV_ITEMS.filter((item) => item.id !== "overview");

  return (
    <div
      className="flex h-full min-h-0 flex-col overflow-hidden"
      data-testid="reports-overview-page"
    >
      <ReportPageHeader
        icon={BarChart3}
        title={t("reports.overview.title")}
        description={t("reports.overview.helper")}
      />

      <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4 md:px-6">
        <ul className="m-0 grid list-none gap-3 p-0 sm:grid-cols-2 xl:grid-cols-4">
          {cards.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.id}>
                <Link
                  to={item.to}
                  className="flex h-full min-h-[7.5rem] flex-col gap-2 rounded-xl border border-line/70 bg-surface p-4 text-start no-underline shadow-[inset_0_1px_0_rgba(255,255,255,0.55)] transition-colors hover:border-line-strong hover:bg-surface-muted/40 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent/50"
                  data-testid={`reports-overview-card-${item.id}`}
                >
                  <span className="inline-grid size-9 place-items-center rounded-xl border border-line/70 bg-surface text-accent shadow-[inset_0_1px_0_rgba(255,255,255,0.75)]">
                    <Icon size={16} aria-hidden="true" />
                  </span>
                  <span className="text-[0.9375rem] font-semibold tracking-[-0.01em] text-foreground">
                    {t(item.labelKey)}
                  </span>
                  <span className="text-[0.75rem] leading-snug text-muted">
                    {t(item.descriptionKey)}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
